import { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { IoMdSettings } from 'react-icons/io';

import { useUIStore } from '@/stores/ui';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { LanguageSelect } from '@/components/ui/language-select';
import { ThemeToggle } from '@/components/ui/theme-toggle';

const languages = [
  { code: 'pt', name: 'pt', flag: '🇧🇷' },
  { code: 'en', name: 'en', flag: '🇺🇸' },
  { code: 'es', name: 'es', flag: '🇪🇸' },
];

export const SystemPreferencesMenu = () => {
  const { t, i18n } = useTranslation();
  const { setLanguage } = useUIStore();
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleLanguageChange = (langCode: string) => {
    void i18n.changeLanguage(langCode);
    setLanguage(langCode);
  };

  return (
    <DropdownMenu open={settingsOpen} onOpenChange={setSettingsOpen}>
      <DropdownMenuTrigger asChild>
        <motion.button
          className="p-2 rounded-full hover:bg-accent transition-colors"
          whileHover={{ scale: 1.15 }}
          whileTap={{ scale: 0.95 }}
          aria-label={t('sidebar.settings') || 'Configurações do sistema'}
          title={t('sidebar.settings') || 'Configurações do sistema'}
        >
          <IoMdSettings className="w-7 h-7 text-foreground" />
        </motion.button>
      </DropdownMenuTrigger>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <DropdownMenuContent
          align="end"
          className="min-w-[320px] p-4 space-y-4"
          style={{ overflow: 'visible' }}
        >
          <div>
            <label className="block text-xs font-medium mb-4 text-muted-foreground">
              {t('sidebar.select_language') || 'Idioma do sistema'}
            </label>
            <LanguageSelect
              languages={languages}
              currentLanguage={i18n.language}
              onLanguageChange={handleLanguageChange}
              collapsed={false}
            />
          </div>
          <div className="flex items-center gap-4">
            <label className="text-xs font-medium text-muted-foreground">
              {t('sidebar.theme') || 'Tema do sistema'}
            </label>
          </div>
          <ThemeToggle />
        </DropdownMenuContent>
      </motion.div>
    </DropdownMenu>
  );
};
